module.exports = __webpack_public_path__ + "h5/img/erweima.087efef8.jpg";